export const PLATFORM_DEFAULTS_EXCLUDED_FIELDS = [
  "step",
  "platform",
  // Budget
  "typeBudget",
  "budget",
  "startDate",
  "endDate",
  // Content
  "template",
  "mediaUrls",
  "multipleItems",
  "imageUrls",
  "videoUrls",
  // Pixel / tracking events (only trackingID is stored as default)
  "trackingCustomEventID",
  "trackingOfflineID",
  "conversionActions",
  // URL not stored as default
  "destinationURL",
];

const EXCLUDED_FIELDS_SET = new Set(PLATFORM_DEFAULTS_EXCLUDED_FIELDS);

export const isEmptyPlatformDefaultsValue = (value) => {
  if (value === "" || value === null || value === undefined) {
    return true;
  }
  if (Array.isArray(value) && value.length === 0) {
    return true;
  }
  return false;
};

const isExcludedField = (key) => EXCLUDED_FIELDS_SET.has(key);

export const pickPlatformDefaultsPayload = ({ candidate = {} }) => {
  const payload = {};

  Object.entries(candidate).forEach(([key, value]) => {
    if (isExcludedField(key) || isEmptyPlatformDefaultsValue(value)) {
      return;
    }
    payload[key] = value;
  });

  return payload;
};

export const pickPlatformDefaultsLoadData = ({ data = {} }) => {
  const loadData = {};

  Object.entries(data).forEach(([key, value]) => {
    if (isExcludedField(key)) {
      return;
    }
    if (value !== undefined) {
      loadData[key] = value;
    }
  });

  return loadData;
};
